export const wealthMountainGraphData = [
  { x: 0, y: 0 },
  { x: 0.01031, y: 0 },
  { x: 0.0136, y: 0 },
  { x: 0.01795, y: 0 },
  { x: 0.02368, y: 0 },
  { x: 0.03125, y: 0 },
  { x: 0.04123, y: 0 },
  { x: 0.05441, y: 0 },
  { x: 0.07179, y: 892 },
  { x: 0.09473, y: 8039 },
  { x: 0.125, y: 54589 },
  { x: 0.16494, y: 211051 },
  { x: 0.21764, y: 774596 },
  { x: 0.28717, y: 2775781 },
  { x: 0.37893, y: 7761289 },
  { x: 0.5, y: 16665095 },
  { x: 0.65975, y: 31728840 },
  { x: 0.87055, y: 56292676 },
  { x: 1.1487, y: 93049082 },
  { x: 1.51572, y: 147193799 },
  { x: 2, y: 225670174 },
  { x: 2.63902, y: 348111442 },
  { x: 3.4822, y: 550804059 },
  { x: 4.59479, y: 802391646 },
  { x: 6.06287, y: 919777382 },
  { x: 8, y: 838424264 },
  { x: 10.55606, y: 718499813 },
  { x: 13.92881, y: 641406935 },
  { x: 18.37917, y: 561542542 },
  { x: 24.25147, y: 476056928 },
  { x: 32, y: 400229218 },
  { x: 42.22425, y: 348838953 },
  { x: 55.71524, y: 310412142 },
  { x: 73.51669, y: 253177910 },
  { x: 97.00586, y: 180543182 },
  { x: 128, y: 113964141 },
  { x: 168.89701, y: 64977249 },
  { x: 222.86094, y: 33359046 },
  { x: 294.06678, y: 17080634 },
  { x: 388.02344, y: 8597029 },
  { x: 512, y: 4387210 },
  { x: 675.58805, y: 2370241 },
  { x: 891.44378, y: 1366388 },
  { x: 1176.26712, y: 820957 },
  { x: 1552.09376, y: 533911 },
  { x: 2048, y: 355166 },
  { x: 2702.3522, y: 239074 },
  { x: 3565.77511, y: 162016 },
  { x: 4705.06846, y: 110172 },
  { x: 6208.37506, y: 75212 },
  { x: 8192, y: 51610 },
];
